// extracted by mini-css-extract-plugin
export default {"ourCoursesContentDesktop":"OurCourses_ourCoursesContentDesktop__A1BH4"};